//const baseApi = 'http://localhost:44355' //Local
//const baseApi = 'https://test.getjuicy.ai' //Test
const baseApi = 'https://backend.reignite.gg' //Live

export default {
   API_URL: baseApi,
   HANGFIRE_URL: `${baseApi}/api/hangfire`,
   GetFileUrl: (id: string | undefined): string | undefined => (id ? `${baseApi}/api/file/${id}` : 'undefined')
}
